import React, { useState, useRef, useEffect } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";
import useScreenType from "./hooks/useScreenType";

import * as Const from "./_Const";

import Navbar from "./components/Navbar";
import Button from "./components/Button";

function PageErrorLogTerminal() {
  const screenType = useScreenType();
  const [data, setData] = useState();
  const { getTerminalLog, eraseTerminalLog } = useFormCtx();
  const textareaRef = useRef(null);

  useEffect(() => {
    async function scopedLoadData() {
      await readLogData();
    }

    scopedLoadData();
  }, []);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [data]);

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "textarea":
          css = "text-sm";
          break;
        case "rows":
          css = "16";
          break;
        case "cols":
          css = "50";
          break;
        case "btn":
          css = "h-14 text-sm";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "textarea":
          css = "text-base";
          break;
        case "rows":
          css = "20";
          break;
        case "cols":
          css = "50";
          break;
        case "btn":
          css = "h-20";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "textarea":
          css = "text-base";
          break;
        case "rows":
          css = "24";
          break;
        case "cols":
          css = "50";
          break;
        case "btn":
          css = "h-20";
          break;
      }
    }

    return css;
  }

  async function readLogData() {
    const result = await getTerminalLog();
    setData(result);
  }

  async function eraseAndReloadLogData() {
    await eraseTerminalLog();
    await readLogData();
  }

  return (
    <>
      <Navbar useCustomTitle={true} customTitle={"Log terminál"} />
      <div className="mt-4 flex flex-col space-y-4 mx-6">
        <textarea
          className={`${getCssFor("textarea")} bg-disabled`}
          ref={textareaRef}
          value={data}
          rows={getCssFor("rows")}
          cols={getCssFor("cols")}
          readOnly
        />
        <div className="flex justify-centera bg-accent-darka">
          <Button type="primary" title="Načíst log z terminálu" showIcon={false} onClick={() => readLogData()} className={`${getCssFor("btn")} `} />
          <Button
            title="Smazat log terminálu"
            showIcon={false}
            className={`${getCssFor("btn")} absolute right-6 bg-error text-white`}
            onClick={async () => await eraseAndReloadLogData()}
          />
        </div>
      </div>
    </>
  );
}

export default PageErrorLogTerminal;
